{
  "GenericAdminList_Footer_Add": "Adicionar",
  "GenericAdminList_Footer_View": "Visualizar",
  "GenericAdminList_Footer_Change": "Mudar",
  "GenericAdminList_Footer_Delete": "Excluir",
  "GenericAdminList_Footer_Selected": "{} Selecionado",
  "GenericAdminList_Footer_NoRows": "Não há nada para ver aqui...",
  "NAME": "GenericAdminListLanguage"
}